import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "tabButton", "panel"]
  static values = { index: Number }
  static classes = [ "inactivePanel" ]

  connect() {
    this.activeTabClasses = (this.data.get("activeTab") || "active").split(' ')
    this.inactiveTabClasses = (this.data.get("inactiveTab") || "inactive").split(' ')
    
    this.showTab()
  }

  change(event) {
    event.preventDefault()

    // If target specifies an index, use that
    if (event.currentTarget.dataset.index) {
      this.index = event.currentTarget.dataset.index

    // If target specifies an id, use that
    } else if (event.currentTarget.dataset.id) {
      this.index = this.tabTargets.findIndex((tab) => tab.id == event.currentTarget.dataset.id)

    // Otherwise, use the index of the current target
    } else {
      this.indexValue = this.tabButtonTargets.indexOf(event.currentTarget)
    }

    this.showTab()
  }

  showTab() {
    this.tabTargets.forEach((tab, index) => {
      const panel = this.panelTargets[index]

      if (index === this.indexValue) {
        panel.classList.remove(this.inactivePanelClass)
        tab.classList.remove(...this.inactiveTabClasses)
        tab.classList.add(...this.activeTabClasses)
      } else {
        panel.classList.add(this.inactivePanelClass)
        tab.classList.remove(...this.activeTabClasses)
        tab.classList.add(...this.inactiveTabClasses)
      }
    })
  }
}
